import moment from 'moment'

import dateMask from './dateMask'

const dateToStrNoTime = (d) => {
    return moment(d).format(dateMask)
}

export default dateToStrNoTime
